<div class="main-content">
  <app-header
    [title]="
      isEdit() ? ('HEADER.TITLE_EDIT_SALES_ORDER_FORM' | translate) : ('HEADER.TITLE_SALES_ORDER_FORM' | translate)
    "
    [subtitle]="
      isEdit()
        ? ('HEADER.SUBTITLE_EDIT_SALES_ORDER_FORM' | translate)
        : ('HEADER.SUBTITLE_SALES_ORDER_DETAIL' | translate)
    "
  />

  <div class="row pt-5 mt-4 mt-md-0">
    <div class="col-12">
      @if (!isSuccess() && !isError() && !deleteSuccess() && !deleteError()) {
        <app-icam-container
          [centralIcon]="true"
          [iconName]="'repository-white'"
          [iconColor]="'#e30714'"
          [iconHeight]="'32px'"
        >
          @if (!isLoading()) {
            <div>
              <form [formGroup]="form" (ngSubmit)="onSubmit()" class="form-container d-flex flex-column">
                <div class="form-section w-100">
                  <div class="d-flex align-items-center form-title mt-2" [ngClass]="isLight() ? 'light' : 'dark'">
                    <div class="d-flex align-items-center p-2">
                      <img class="section-image" src="../../assets/icon/repository-white.svg" alt="article" />
                    </div>
                    <div class="form-title-text-container">
                      <p class="my-0 py-0" [ngClass]="isLight() ? 'light' : 'dark'">
                        {{ 'SALES_ORDER_FORM.DETAILS_ODV' | translate }}
                      </p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="input-wrapper">
                        <label for="machineAccount">{{ 'SALES_ORDER_FORM.MACHINE_ACCOUNT' | translate }}</label>
                        <app-icam-autocomplete-select
                          formControlName="machineAccount"
                          [placeholder]="'SALES_ORDER_FORM.MACHINE_ACCOUNT_PLACEHOLDER' | translate"
                          [options]="machineAccountOptions"
                          [displayField]="'accountName'"
                          [valueField]="'accountId'"
                          [filterFields]="['accountName', 'accountId']"
                          [required]="false"
                          [fetchFn]="fetchMachineAccounts"
                          id="machineAccount"
                          [disabled]="isEdit()"
                          [hideClear]="isEdit()"
                        ></app-icam-autocomplete-select>
                      </div>
                    </div>
                  </div>
                  @if (form.get('machineAccount')?.value && machinesByAccount.length > 0) {
                    <div class="machines-container mt-2">
                      @for (accountGroup of machinesByAccount; track accountGroup) {
                        <div class="account-group mb-4">
                          <div class="machines-list">
                            @for (machine of accountGroup.machines; track machine) {
                              <div class="machine-item form-check mb-2">
                                <input
                                  #machineCheckbox
                                  class="form-check-input"
                                  type="checkbox"
                                  [id]="'machine-' + machine.id"
                                  [checked]="isMachineSelected(machine.id || '')"
                                  (change)="onMachineSelection(machine, machineCheckbox.checked)"
                                  [ngClass]="isLight() ? 'light' : 'dark'"
                                  [disabled]="!canEditMachines()"
                                />
                                <label
                                  class="form-check-label"
                                  [for]="'machine-' + machine.id"
                                  [appTooltip]="
                                    'SN: ' + machine.serialNumber + ' | Account: ' + accountGroup.accountName
                                  "
                                >
                                  {{ machine.assetName || 'N/A' }}
                                </label>
                              </div>
                            }
                          </div>
                        </div>
                      }
                      @if (machinesByAccount.length === 0) {
                        <div class="no-machines-message">
                          {{ 'SALES_ORDER_FORM.NO_MACHINES' | translate }}
                        </div>
                      }
                    </div>
                  }
                  <div class="row">
                    <div class="col-12">
                      <div class="input-wrapper">
                        <label for="reqDocName">{{ 'SALES_ORDER_FORM.SALES_ORDER_NUMBER' | translate }}*</label>
                        <app-icam-input
                          label="{{ 'SALES_ORDER_FORM.SALES_ORDER_NUMBER' | translate }}"
                          inputId="reqDocName"
                          [isSlim]="true"
                          inputType="text"
                          formControlName="reqDocName"
                          [placeholder]="'SALES_ORDER_FORM.SALES_ORDER_NUMBER' | translate"
                          [ngClass]="isLight() ? 'light' : 'dark'"
                          [required]="true"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row" *appHasRole="['ADMIN', 'CUSTOMER', 'PARTNER']">
                    <div class="col-12">
                      <div class="input-wrapper">
                        <label for="salesOrderFile">{{ 'SALES_ORDER_FORM.SALES_ORDER_FILE' | translate }}*</label>
                        @if (!isEdit()) {
                          <div class="d-flex align-items-center gap-2">
                            <label
                              for="salesOrderFile"
                              class="custom-file-upload"
                              [ngClass]="isLight() ? 'light' : 'dark'"
                            >
                              <app-icam-icon iconName="attachment" />
                              {{ 'SALES_ORDER_FORM.CHOOSE_FILE' | translate }}
                            </label>
                            <div
                              class="popover-trigger"
                              ngbPopover="{{ 'acceptedFiles' | translate }}{{ 'docs' | translate }}"
                              triggers="mouseenter:mouseleave"
                              popoverClass="icam-popover {{ isLight() ? 'light' : 'dark' }}"
                            >
                              <app-icam-icon [iconName]="'info-circle'" />
                            </div>
                          </div>
                          <input
                            id="salesOrderFile"
                            type="file"
                            style="display: none"
                            (change)="onFileSelected($event)"
                            accept=".pdf,.doc,.docx"
                          />
                        }

                        @if (salesOrderFile) {
                          <p class="text-muted" [ngClass]="isLight() ? 'light' : 'dark'">
                            {{ salesOrderFile.name }}
                            @if (!isEdit()) {
                              <small
                                class="text-decoration-underline"
                                role="button"
                                (click)="removeFileAttachment()"
                                (keydown.enter)="removeFileAttachment()"
                                tabindex="0"
                              >
                                ({{ 'COMMON.REMOVE' | translate }})
                              </small>
                            }
                          </p>
                        }
                        @if (!salesOrderFile && existingFile) {
                          <p class="text-muted" [ngClass]="isLight() ? 'light' : 'dark'">
                            {{ existingFile.fileName }}
                            <small
                              class="text-decoration-underline ms-2"
                              role="button"
                              (click)="downloadAttachment(_salesOrder.attachmentId, existingFile.fileName)"
                              (keydown.enter)="downloadAttachment(_salesOrder.attachmentId, existingFile.fileName)"
                              tabindex="0"
                            >
                              ({{ 'COMMON.DOWNLOAD' | translate }})
                            </small>
                            @if (!isEdit()) {
                              <small
                                class="text-decoration-underline ms-2"
                                role="button"
                                (click)="removeFileAttachment()"
                                (keydown.enter)="removeFileAttachment()"
                                tabindex="0"
                              >
                                ({{ 'COMMON.REMOVE' | translate }})
                              </small>
                            }
                          </p>
                        }
                        @if (form.get('salesOrderFile')?.touched && !salesOrderFile && !existingFile) {
                          <div class="invalid-feedback d-block">
                            {{ 'SALES_ORDER_FORM.REQUIRED_FIELD' | translate }}
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                  @if (canEditMachines()) {
                    <div class="row">
                      <div class="col-12">
                        <button
                          type="submit"
                          class="button-form-submit"
                          [class.disabled]="
                            isLoading() || (isEdit() ? !hasMachineSelectionChanged() : !form.valid || !isFileValid())
                          "
                          [disabled]="
                            isLoading() || (isEdit() ? !hasMachineSelectionChanged() : !form.valid || !isFileValid())
                          "
                        >
                          @if (isLoading()) {
                            <div class="d-flex justify-content-center">
                              <div class="spinner-border spinner-border-sm" role="status"></div>
                            </div>
                          } @else {
                            {{
                              isEdit()
                                ? ('SALES_ORDER_FORM.SAVE_CHANGES' | translate)
                                : ('SALES_ORDER_FORM.CREATE_SALES_ORDER' | translate)
                            }}
                          }
                        </button>
                      </div>
                    </div>
                  }
                </div>
              </form>
            </div>
          }
          @if (isLoading()) {
            <div class="loading-container text-center py-5">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">{{ 'COMMON.LOADING' | translate }}</span>
              </div>
              <p class="mt-3">{{ 'COMMON.LOADING' | translate }}</p>
            </div>
          }
        </app-icam-container>
      }

      @if (isSuccess() && !deleteSuccess()) {
        <app-icam-container [centralIcon]="true" [iconName]="'OK'" [iconColor]="'#00A5A9'" [iconHeight]="'60px'">
          <div class="central-content w-100 text-center d-flex flex-column align-items-center">
            <h1 class="success-title mt-4">
              {{ (isEdit() ? 'SALES_ORDER_FORM.UPDATE_SUCCESS' : 'SALES_ORDER_FORM.CREATE_SUCCESS') | translate }}
            </h1>
            <p class="subtitle my-3">
              {{
                (isEdit()
                  ? 'SALES_ORDER_FORM.UPDATED_SALES_ORDER_DESCRIPTION'
                  : 'SALES_ORDER_FORM.CREATED_SALES_ORDER_DESCRIPTION'
                ) | translate
              }}
            </p>
            <button class="btn btn-primary mt-3" (click)="goToList()">
              {{ 'COMMON.RETURN_TO_LIST' | translate }}
            </button>
          </div>
        </app-icam-container>
      }

      <!-- Error State -->
      @if (isError() && !deleteError()) {
        <app-icam-container [centralIcon]="true" [iconName]="'KO'" [iconColor]="'#e30714'" [iconHeight]="'60px'">
          <div class="central-content w-100 text-center d-flex flex-column align-items-center">
            <h1 class="error-title mt-4">
              {{ (isEdit() ? 'SALES_ORDER_FORM.UPDATE_ERROR' : 'SALES_ORDER_FORM.CREATE_ERROR') | translate }}
            </h1>
            <p class="subtitle my-3">
              {{
                (isEdit() ? 'SALES_ORDER_FORM.UPDATE_ERROR_DESCRIPTION' : 'SALES_ORDER_FORM.CREATE_ERROR_DESCRIPTION')
                  | translate
              }}
            </p>
            @if (errorMessage()) {
              <div class="text-danger validation-errors">
                @for (line of errorMessage().split('\n'); track line) {
                  <p>{{ line }}</p>
                }
              </div>
            }
            <div class="d-flex mt-3 gap-3">
              <button class="btn btn-primary" (click)="isError.set(false)">
                {{ 'COMMON.TRY_AGAIN' | translate }}
              </button>
              <button class="btn btn-outline-primary" (click)="goToList()">
                {{ 'COMMON.RETURN_TO_LIST' | translate }}
              </button>
            </div>
          </div>
        </app-icam-container>
      }

      @if (deleteSuccess()) {
        <app-icam-container [centralIcon]="true" [iconName]="'OK'" [iconColor]="'#00A5A9'" [iconHeight]="'60px'">
          <div class="central-content w-100 text-center d-flex flex-column align-items-center">
            <h1 class="success-title mt-4">
              {{ getDeleteSuccessTitle() | translate }}
            </h1>
            <p class="subtitle my-3">
              {{ getDeleteSuccessDescription() | translate }}
            </p>
            <button class="btn btn-primary mt-3" (click)="goToList()">
              {{ 'COMMON.RETURN_TO_LIST' | translate }}
            </button>
          </div>
        </app-icam-container>
      }

      @if (deleteError()) {
        <app-icam-container [centralIcon]="true" [iconName]="'KO'" [iconColor]="'#e30714'" [iconHeight]="'60px'">
          <div class="central-content w-100 text-center d-flex flex-column align-items-center">
            <h1 class="error-title mt-4">
              {{ getDeleteErrorTitle() | translate }}
            </h1>
            <p class="subtitle my-3">
              {{ getDeleteErrorDescription() | translate }}
            </p>
            @if (errorMessage()) {
              <div class="text-danger validation-errors">
                @for (line of errorMessage().split('\n'); track line) {
                  <p>{{ line }}</p>
                }
              </div>
            }
            <div class="d-flex mt-3 gap-3">
              <button class="btn btn-primary" (click)="deleteError.set(false); isError.set(false)">
                {{ 'COMMON.TRY_AGAIN' | translate }}
              </button>
              <button class="btn btn-outline-primary" (click)="goToList()">
                {{ 'COMMON.RETURN_TO_LIST' | translate }}
              </button>
            </div>
          </div>
        </app-icam-container>
      }

      <div class="form-footer d-flex justify-content-between mt-4">
        <app-back-button
          class="app-back-button"
          [linkText]="'REQ_DOC_FORM.BACK_TO_LIST' | translate"
          (click)="goBack()"
        ></app-back-button>

        @if (!isSuccess() && !isError() && !deleteSuccess() && !deleteError() && _salesOrderId) {
          <button
            type="button"
            [ngClass]="isLight() ? 'btn btn-outline-danger' : 'btn btn-outline-light'"
            (click)="deleteSalesOrder()"
            [class.disabled]="isLoading()"
            [disabled]="isLoading()"
            *appHasRole="['ADMIN']"
          >
            @if (isLoading()) {
              <div class="d-flex justify-content-center">
                <div class="spinner-border spinner-border-sm" role="status"></div>
              </div>
            } @else {
              {{ getDeleteButtonText() | translate }}
            }
          </button>
        }
      </div>
    </div>
  </div>
</div>
<app-footer-copyright />
